// extracted by mini-css-extract-plugin
export var avatarContainer = "_5z-1";
export var largeAvatarContainer = "_5z-2";
export var smallAvatarContainer = "_5z-0";